// Shared right-offset edge resolution for the main chart and every indicator sub-panel.
//
// All panels (candles/line + RSI/MACD/Stoch/ATR/CCI/WilliamsR/ADX) draw on the same time
// axis and must compute their right-side offset from the SAME reference time, or they drift
// apart horizontally. While panning, anchor the edge to the viewport itself. This keeps the
// time transform constant: historical candles fill the right-offset area, while only the
// actual live edge leaves it empty. Tying the edge to the latest candle instead caused the
// scale to change as that candle entered the viewport, pulling it abruptly toward the live slot.
//
// Keep this as the single source of truth — duplicating the logic per panel is exactly what
// caused candles and indicators to desync. See [[chart-drag-speed-emptyspace-edge]].
export function resolveEmptySpaceEdge(params: {
  isDragging: boolean;
  // Effective scroll offset — pass the ref value (scrollOffsetRef.current) so it matches the
  // signal getViewportTime() uses; the React `scrollOffset` prop lags it by a frame.
  scrollOffset: number;
  rawLastDataTime: number;
  currentViewportTime: number;
  frozenRef: { current: number };
  wasLiveRef: { current: boolean };
}): number {
  const { isDragging, scrollOffset, rawLastDataTime, currentViewportTime, frozenRef, wasLiveRef } = params;

  const isLive = !isDragging && scrollOffset === 0;
  if (isLive) {
    frozenRef.current = rawLastDataTime;
  } else {
    frozenRef.current = currentViewportTime;
  }
  wasLiveRef.current = isLive;

  return isLive ? rawLastDataTime : currentViewportTime;
}
